import axios from 'axios'
import swal from 'sweetalert'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

let defaultState = {
  fetchingResourcePosts: false,
  fetchingTags: false,
  posts: [],
  currentPost: null,
  fetchingCurrentPost: false,
  tags: [],
  searchTerm: "",
  userFilter: [],
  sort: "",
  tagFilter: [],
  currentPage: 1,
  postsPerPage: 8,
  postCount: 0,
}

export default function manageResourcePosts(state = defaultState, action){
  switch (action.type) {
    case "FETCHING_RESOURCE_POSTS":
      return { ...state, fetchingResourcePosts: true }
    case "FETCHING_TAGS":
      return { ...state, fetchingTags: true }
    case "SET_RESOURCE_POSTS":
      return { ...state, posts: action.payload.results, fetchingResourcePosts: false, postCount: action.payload.count, postsPerPage: action.payload.results_per_page  }
    case "FETCHING_CURRENT_POST":
      return {...state, fetchingCurrentPost: true, currentPost: null}
    case "SET_CURRENT_POST":
      const tags = Array.from(new Set([...state.tags, ...action.payload.tags ]))
      return {...state, currentPost: action.payload, fetchingCurrentPost: false, tags }
    case "SET_TAGS":
      return { ...state, tags: action.payload, fetchingTags: false }
    case "REMOVE_DOCUMENT_FROM_CURRENT_POST":
        const documents = state.currentPost.documents.filter(doc => {
          return doc.id !== action.payload
        })
        return {...state, currentPost: {...state.currentPost, documents}}
    case "CHANGE_POSTS_PAGE":
      return { ...state, currentPage: action.payload }
    case "CHANGE_SEARCH_TERM":
      return { ...state, searchTerm: action.payload }
    case "CHANGE_USER_FILTER":
      return { ...state, userFilter: action.payload }
    case "CHANGE_TAG_FILTER":
      return { ...state, tagFilter: action.payload }
    case "CHANGE_SORT":
      return { ...state, sort: action.payload }
    default:
      return state
  }
}

const fetchingResourcePosts = () => {
  return { type: "FETCHING_RESOURCE_POSTS" }
}

const fetchingTags = () => {
  return { type: "FETCHING_TAGS" }
}

const setResourcePosts = (resourcePosts) => {
  return { type: "SET_RESOURCE_POSTS", payload: resourcePosts}
}

export const fetchingCurrentPost = () => {
  return { type: "FETCHING_CURRENT_POST"}
}

export const setCurrentPost = (post) => {
  return { type: "SET_CURRENT_POST", payload: post}
}

const setTags = (tags) => {
  return { type: "SET_TAGS", payload: tags}
}

export const removeDocumentFromCurrentPost = (id) => {
  return { type: "REMOVE_DOCUMENT_FROM_CURRENT_POST", payload: id}
}

export const changePage = (page) => {
  return { type: "CHANGE_POSTS_PAGE", payload: page }
}

export const changeSearchTerm = (searchTerm) => {
  return { type: "CHANGE_SEARCH_TERM", payload: searchTerm }
}

export const changeTagFilter = (tagFilter) => {
  return { type: "CHANGE_TAG_FILTER", payload: tagFilter }
}

export const changeUserFilter = (userFilter) => {
  return { type: "CHANGE_USER_FILTER", payload: userFilter }
}

export const changeSort = (sort) => {
  return { type: "CHANGE_SORT", payload: sort }
}

export const getResourcePosts = (page, filters, sort_by) => {
  if (!page) {
    page = 1
  }
  return function(dispatch) {
    dispatch(fetchingResourcePosts())
    axios.get(`${getServerURL()}resource-posts/resource-posts/?page=${page}`,
      {
        headers: {"Authorization": "Bearer "+localStorage.getItem("token")},
        params: {
          filters,
          sort_by,
        }
      }
    )
    .then(response => {
      dispatch(setResourcePosts(response.data))
      dispatch(changePage(page))
    })
    .catch(error => {
      handleErrorFetchingData(error)
    })
  }
}

export const getCurrentPost = (id) => {
  return function(dispatch) {
    dispatch(fetchingCurrentPost())
    axios.get(`${getServerURL()}resource-posts/resource-posts/${id}/`,
      { headers: {"Authorization": "Bearer "+localStorage.getItem("token")} }
    )
    .then(response => {
      dispatch(setCurrentPost(response.data))
    })
    .catch(error => {
      dispatch(setCurrentPost(null))
      handleErrorFetchingData(error)
    })
  }
}

export const getTags = () => {
  return function(dispatch) {
    dispatch(fetchingTags())
    axios.get(`${getServerURL()}resource-posts/tags/`,{
      headers:{"Authorization": "Bearer "+localStorage.getItem("token")}
    })
    .then(response => {
      dispatch(setTags(response.data))
    })
    .catch(error => {
      handleErrorFetchingData(error)
    })
  }
}

export const deleteResourcePostDocument = (documentId) => {
  return (dispatch) => {
    axios({
      url: `${getServerURL()}resource-posts/resource-post-documents/${documentId}/`,
      method: "DELETE",
      headers:{"Authorization": "Bearer "+localStorage.getItem("token")},
    })
    .then(response => {
      swal({
        title: "Document Deleted",
        text: "The document was deleted",
        icon: "success",
        button: "Continue",
      })
      dispatch(removeDocumentFromCurrentPost(documentId))
    })
    .catch(error => {
      const message = 'There was an error deleting the document.'
      handleErrorFetchingData(error, message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/resource-posts/reducers/manageResourcePosts.js